<template>
  <div id="app">
    <template v-if="signedIn">
      <template v-if="isAdviser">
        <HeaderItem :signedIn="true" :isAdviser="true" :isStaff="false" :id="id" />
      </template>
      <template v-else-if="isStaff">
        <HeaderItem :signedIn="true" :isAdviser="false" :isStaff="true" :id="id" />
      </template>
      <template v-else>
        <HeaderItem :signedIn="true" :isAdviser="false" :isStaff="false" :id="id" />
      </template>
    </template>
    <template v-else>
      <template v-if="isAdviser">
        <HeaderItem :signedIn="false" :isAdviser="true" :isStaff="false" :id="id" />
      </template>
      <template v-else>
        <HeaderItem :signedIn="false" :isAdviser="false" :isStaff="false" :id="id" />
      </template>
    </template>
    <main class="common-main">
      <!-- 認証済みの時はメインの画面を表示 -->
      <template v-if="signedIn">
        <h2 class="common-title">相談内容</h2>

        <!-- 認証済みの時はメインの画面を表示 -->
        <template v-if="isLoading">
          <div class="loading"></div>
        </template>
        <div v-else-if="isOwnTopics">
          <div class="text-box">
            <div v-if="isAdviser && counselingUserData.isOfficialTestAccount">
              <h3 style="color:red; margin:5px">本相談は「CancerWith公式のテストアカウント」によるものです。アドバイザーの回答投稿のテストにもご利用いただけます。</h3>
            </div>
            <div v-else-if="isStaff && counselingUserData.isOfficialTestAccount">
              <h3 style="color:red; margin:5px">本相談は「CancerWith公式のテストアカウント」によるものです。アドバイザーの回答投稿のテストにもご利用いただけます。</h3>
            </div>
            <div class="question-status">
              <template v-if="status === '相談中'">
                <div class="status-label label-ing">{{status}}</div>
              </template>
              <template v-else>
                <div class="status-label label-ed">{{status}}</div>
              </template>
              <div class="list-date">{{createAt}}</div>
            </div>
            <div class="item question-answer">
              <div class="answer-status">
                <div class="avator-icon">
                  <img :src="counselingUserData.iconUrl" width="150"/>
                </div>
                <dl class="answer-person">
                  <dt class="answer-name">{{counselingUserData.displayName}}</dt>
                  <dd class="answer-status">相談者</dd>
                </dl>
                <div class="answer-date">{{counselingUserData.createAt | date}}</div>
              </div>
            </div>
            <p class="question-text" v-html="counselingText"></p>
            <ul v-if="relatedLinkUrl1" class="related-link">
              <li v-if="relatedLinkUrl1"><strong>関連リンク1：</strong><a :href=relatedLinkUrl1>{{relatedLinkUrl1 | decodeURI}}</a></li>
              <li v-if="relatedLinkUrl2"><strong>関連リンク2：</strong><a :href=relatedLinkUrl2>{{relatedLinkUrl2 | decodeURI}}</a></li>
              <li v-if="relatedLinkUrl3"><strong>関連リンク3：</strong><a :href=relatedLinkUrl3>{{relatedLinkUrl3 | decodeURI}}</a></li>
              <li v-if="relatedLinkUrl4"><strong>関連リンク4：</strong><a :href=relatedLinkUrl4>{{relatedLinkUrl4 | decodeURI}}</a></li>
              <li v-if="relatedLinkUrl5"><strong>関連リンク5：</strong><a :href=relatedLinkUrl5>{{relatedLinkUrl5 | decodeURI}}</a></li>
            </ul>
            <table v-show="imageUrl1"><tr>
              <td v-show="imageUrl1"><div v-show="imageUrl1" class="p_box more_icon"><img v-show="imageUrl1" :src="imageUrl1" style="max-width:150px" v-on:click="openImage(imageUrl1)" hspace="3"/></div></td>
              <td v-show="imageUrl2"><div v-show="imageUrl2" class="p_box more_icon"><img v-show="imageUrl2" :src="imageUrl2" style="max-width:150px" v-on:click="openImage(imageUrl2)" hspace="3"/></div></td>
              <td v-show="imageUrl3"><div v-show="imageUrl3" class="p_box more_icon"><img v-show="imageUrl3" :src="imageUrl3" style="max-width:150px" v-on:click="openImage(imageUrl3)" hspace="3"/></div></td>
            </tr></table>
            <div class="overlay" v-show="showImage" v-on:click="closeImage">
              <div class="overlay-content">
                <img :src="overlayImageUrl" style="max-width:100%" vspace="3"/>
                <p><button v-on:click="closeImage">閉じる</button></p>
              </div>
            </div>
          </div>
          <div class="item question-outertext">
            <div>カテゴリ：{{counselingCategory1}} - {{counselingCategory2}}</div>
            <template v-if="status === '相談中'">
              <template v-if="lastResponseReplierType !== 'adviser'">
                <div v-if="isAdviser">回答をお願いします</div>
                <div v-else>回答をお待ちください</div>
                <div v-if="isAdviser" class="text-red">回答期限： {{responseEstimatedDate | date('responseEstimatedDate')}}</div>
                <div v-else class="text-red">回答予定： {{responseEstimatedDate | date('responseEstimatedDate')}}</div>
              </template>
            </template>
            <div><a v-bind:href="violationReportsUrl">【通報】</a></div>
            <br>
            <button @click="showProfile = !showProfile">
              相談者のプロフィール
            </button>
            <transition name="fadeProfile">
              <div class="text-box question-outerprofiletext" v-if="showProfile">
                <h3>相談者のプロフィール</h3>
                <ul>
                  <li><b>性別</b>： {{counselingUserData.gender}}</li>
                  <li><b>年齢</b>： {{counselingUserData.age}}</li>
                  <li><b>続柄</b>： {{counselingUserData.relationship}}</li>
                  <li><b>がん種</b>： {{counselingUserData.cancerType}}</li>
                  <li><b>ステージ</b>： {{counselingUserData.cancerStage}}</li>
                  <li><b>がんが発見されたきっかけ</b>： {{counselingUserData.diagnosedReason}}</li>
                  <li><b>がんと診断された年月日</b>： {{counselingUserData.diagnosedDate}}</li>
                  <li><b>現在かかっている病院・診療科</b>： {{counselingUserData.hospitalName}}</li>
                  <li><b>現在の状況</b>： {{counselingUserData.curativeStatus}}</li>
                </ul>
                <a :href="'/profile/' + counselingUserid"><button class="footerNavi-button button-secondary">プロフィール</button></a>
              </div>
            </transition>
            <br><br>
            <button @click="showPastCounseling = !showPastCounseling">
              相談者の過去の相談（直近10件まで）
            </button>
            <transition name="fadePastCounseling">
              <ul class="text-box list-wrap pastCounseling-list" v-if="showPastCounseling">
                <li class="list-body" v-for="pastCounseling in pastCounselingData" :key="pastCounseling.id">
                  <a v-if="pastCounseling.id" :href="'/counselingDetail/' + pastCounseling.id">
                    <div class="list-status">
                      <template v-if="pastCounseling.status === '相談中'">
                        <div class="status-label label-ing">{{pastCounseling.status}}</div>
                      </template>
                      <template v-else>
                        <div class="status-label label-ed">{{pastCounseling.status}}</div>
                      </template>
                      <div class="list-date">{{pastCounseling.createAt | date}}</div>
                    </div>
                    <div class="list-main">
                      <p class="listbody-text">{{pastCounseling.counselingText | truncate}}</p>
                    </div>
                    <div class="list-foot">
                      <div class="foot-inner">
                        <div>カテゴリ：{{pastCounseling.counselingCategory1}} - {{pastCounseling.counselingCategory2}}</div>
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
            </transition>
          </div>
          <template v-if="isReplyLoading">
            <div class="loading"></div>
          </template>
          <template v-else>
            <div v-for="counselingReplies in counselingRepliedData" :key="counselingReplies.id"><!-- box-green box-blue box-yellow box-red -->
              <template v-if="counselingReplies.replierType === 'adviser'">
                <div class="text-box box-green">
                  <div class="item question-answer">
                    <div class="answer-status">
                      <!--<a :href="'../profile/' + counselingReplies.replierUserid">-->
                        <div class="avator-icon">
                          <img :src="counselingReplies.iconUrl" width="150"/>
                        </div>
                      <!--</a>-->
                      <!--<a :href="'../profile/' + counselingReplies.replierUserid">-->
                        <dl class="answer-person">
                          <dt class="answer-name">{{counselingReplies.displayName}}</dt>
                          <dd class="answer-status">{{counselingReplies.affiliation}} - {{counselingReplies.businessTitle}}</dd>
                        </dl>
                      <!--</a>-->
                      <div class="answer-date">{{counselingReplies.createAt | date}}</div>
                    </div>
                  </div>
                  <p class="answer-text" v-html="counselingReplies.replyText"></p>
                  <ul v-if="counselingReplies.relatedLinkUrl1" class="related-link">
                    <li v-if="counselingReplies.relatedLinkUrl1"><strong>関連リンク1：</strong><a :href=counselingReplies.relatedLinkUrl1>{{counselingReplies.relatedLinkUrl1 | decodeURI}}</a></li>
                    <li v-if="counselingReplies.relatedLinkUrl2"><strong>関連リンク2：</strong><a :href=counselingReplies.relatedLinkUrl2>{{counselingReplies.relatedLinkUrl2 | decodeURI}}</a></li>
                    <li v-if="counselingReplies.relatedLinkUrl3"><strong>関連リンク3：</strong><a :href=counselingReplies.relatedLinkUrl3>{{counselingReplies.relatedLinkUrl3 | decodeURI}}</a></li>
                    <li v-if="counselingReplies.relatedLinkUrl4"><strong>関連リンク4：</strong><a :href=counselingReplies.relatedLinkUrl4>{{counselingReplies.relatedLinkUrl4 | decodeURI}}</a></li>
                    <li v-if="counselingReplies.relatedLinkUrl5"><strong>関連リンク5：</strong><a :href=counselingReplies.relatedLinkUrl5>{{counselingReplies.relatedLinkUrl5 | decodeURI}}</a></li>
                  </ul>
                  <table v-show="counselingReplies.imageUrl1"><tr>
                    <td v-show="counselingReplies.imageUrl1"><div v-show="counselingReplies.imageUrl1" class="p_box more_icon"><img v-show="counselingReplies.imageUrl1" :src="counselingReplies.imageUrl1" style="max-width:150px" v-on:click="openImage(counselingReplies.imageUrl1)" hspace="3"/></div></td>
                    <td v-show="counselingReplies.imageUrl2"><div v-show="counselingReplies.imageUrl2" class="p_box more_icon"><img v-show="counselingReplies.imageUrl2" :src="counselingReplies.imageUrl2" style="max-width:150px" v-on:click="openImage(counselingReplies.imageUrl2)" hspace="3"/></div></td>
                    <td v-show="counselingReplies.imageUrl3"><div v-show="counselingReplies.imageUrl3" class="p_box more_icon"><img v-show="counselingReplies.imageUrl3" :src="counselingReplies.imageUrl3" style="max-width:150px" v-on:click="openImage(counselingReplies.imageUrl3)" hspace="3"/></div></td>
                  </tr></table>
                </div>
              </template>
              <template v-else>
                <div class="text-box box-yellow">
                  <div class="item question-answer">
                    <div class="answer-status">
                      <!--<a :href="'../profile/' + counselingReplies.replierUserid">-->
                        <div class="avator-icon">
                          <img :src="counselingReplies.iconUrl" width="150"/>
                        </div>
                      <!--</a>-->
                      <!--<a :href="'../profile/' + counselingReplies.replierUserid">-->
                        <dl class="answer-person">
                          <dt class="answer-name">{{counselingReplies.displayName}}</dt>
                          <dd class="answer-status">相談者</dd>
                        </dl>
                      <!--</a>-->
                      <div class="answer-date">{{counselingReplies.createAt | date}}</div>
                    </div>
                  </div>
                  <p class="answer-text" v-html="counselingReplies.replyText"></p>
                  <ul v-if="counselingReplies.relatedLinkUrl1" class="related-link">
                    <li v-if="counselingReplies.relatedLinkUrl1"><strong>関連リンク1：</strong><a :href=counselingReplies.relatedLinkUrl1>{{counselingReplies.relatedLinkUrl1 | decodeURI}}</a></li>
                    <li v-if="counselingReplies.relatedLinkUrl2"><strong>関連リンク2：</strong><a :href=counselingReplies.relatedLinkUrl2>{{counselingReplies.relatedLinkUrl2 | decodeURI}}</a></li>
                    <li v-if="counselingReplies.relatedLinkUrl3"><strong>関連リンク3：</strong><a :href=counselingReplies.relatedLinkUrl3>{{counselingReplies.relatedLinkUrl3 | decodeURI}}</a></li>
                    <li v-if="counselingReplies.relatedLinkUrl4"><strong>関連リンク4：</strong><a :href=counselingReplies.relatedLinkUrl4>{{counselingReplies.relatedLinkUrl4 | decodeURI}}</a></li>
                    <li v-if="counselingReplies.relatedLinkUrl5"><strong>関連リンク5：</strong><a :href=counselingReplies.relatedLinkUrl5>{{counselingReplies.relatedLinkUrl5 | decodeURI}}</a></li>
                  </ul>
                  <table v-show="counselingReplies.imageUrl1"><tr>
                    <td v-show="counselingReplies.imageUrl1"><div v-show="counselingReplies.imageUrl1" class="p_box more_icon"><img v-show="counselingReplies.imageUrl1" :src="counselingReplies.imageUrl1" style="max-width:150px" v-on:click="openImage(counselingReplies.imageUrl1)" hspace="3"/></div></td>
                    <td v-show="counselingReplies.imageUrl2"><div v-show="counselingReplies.imageUrl2" class="p_box more_icon"><img v-show="counselingReplies.imageUrl2" :src="counselingReplies.imageUrl2" style="max-width:150px" v-on:click="openImage(counselingReplies.imageUrl2)" hspace="3"/></div></td>
                    <td v-show="counselingReplies.imageUrl3"><div v-show="counselingReplies.imageUrl3" class="p_box more_icon"><img v-show="counselingReplies.imageUrl3" :src="counselingReplies.imageUrl3" style="max-width:150px" v-on:click="openImage(counselingReplies.imageUrl3)" hspace="3"/></div></td>
                  </tr></table>
                </div>
              </template>
            </div>
          </template>

          <template v-if="isAdviser">
          </template>
          <template v-else-if="isStaff">
          </template>
          <template v-else>
            <div class="content-footerNavi">
              <template v-if="isSolved">
                <button class="footerNavi-button button-secondary button-short" style="background-color:#fbe0de">
                  <a v-bind:href="ratingsUrl">
                    相談を評価する
                  </a>
                </button>
              </template>
              <template v-else>
                <button class="footerNavi-button button-secondary button-short">
                  <a href="/counselingDetail">
                    別の相談もする
                  </a>
                </button>
              </template>
              <template v-if="isSolved">
                <template v-if="paymentActiveStatus">
                  <button v-if="paymentMode === '有料プランご利用中'" class="footerNavi-button button-short" v-bind:class="{'button-secondary':isActiveButtonSecondary, 'button-disabled':isActiveSecondButtonDisabled}" v-on:click="changeSolvedStatus(false)">
                    相談を再開する
                  </button>
                  <button v-else class="footerNavi-button button-short button-disabled">
                    相談を再開する
                  </button>
                </template>
                <template v-else>
                  <button class="footerNavi-button button-short" v-bind:class="{'button-secondary':isActiveButtonSecondary, 'button-disabled':isActiveSecondButtonDisabled}" v-on:click="changeSolvedStatus(false)">
                    相談を再開する
                  </button>
                </template>
              </template>
              <template v-else>
                <button class="footerNavi-button button-short" v-bind:class="{'button-secondary':isActiveButtonSecondary, 'button-disabled':isActiveSecondButtonDisabled}" v-on:click="changeSolvedStatus(true)">
                  解決しました
                </button>
              </template>
            </div>
            <template v-if="paymentActiveStatus">
              <template v-if="isSolved">
                <div class="guide-module item" v-if="paymentMode !== '有料プランご利用中'">
                  <div class="guide-module-item">
                    <h3 class="module-title">相談を再開しますか？</h3>
                    <span>有料プランをご利用いただくと、相談をいつでも再開させることができます<br>
                    一度解決した相談内容も、後日再開させて継続的に解決に向けて相談可能です。</span>
                  </div>
                  <div style="margin:0 0 10px 15px">
                    <a :href="adviserLink" target="_blank">
                      <img :src="adviserImage" width="64px" style="border-radius:50%">
                    </a> <b>{{adviserName}}</b>
                  </div>
                  <div class="item">
                    <a href="/payment"><button class="footerNavi-button button-primary">有料プラン（月額3,980円）を利用開始</button></a>
                  </div>
                </div>
              </template>
            </template>
          </template>


          <template v-if="status === '相談中'">
            <template v-if="isStaff">
              <dl class="item">
                <dt class="profile-title">運営アカウントは返信できません</dt>
              </dl>
            </template>
            <template v-else>
              <template v-if="paymentMode !== '有料プランご利用中' && paymentActiveStatus">
                <div class="guide-module-item">
                  <h3 class="module-title">さらに返信を続けますか？</h3>
                  <span>有料プランではないため返信ができません。<br>
                    有料プランをご利用いただくと、返信件数の制限なくご利用いただけます。</span>
                </div>
                <div style="margin:0 0 10px 15px">
                  <a :href="adviserLink" target="_blank">
                    <img :src="adviserImage" width="64px" style="border-radius:50%">
                  </a> <b>{{adviserName}}</b>
                </div>
                <div class="item">
                  <a href="/payment"><button class="footerNavi-button button-primary">有料プラン（月額3,980円）を利用開始</button></a>
                </div>
              </template>
              <template v-else-if="counselingRepliedCount >= 10">
                <div class="guide-module">
                  <div class="guide-module-item">
                    <h3 class="module-title">1回の相談で可能な返信は10件までです。継続してアドバイザーに相談したい場合は「新しい相談」を作成してください。</h3>
                    <span>引き続きアドバイザーと対話したい場合や、アドバイザーと対話する中で新たな相談が出た場合は「新しい相談」を作成しましょう。</span>
                  </div>
                  <div style="margin:0 0 10px 15px">
                    <a :href="adviserLink" target="_blank">
                      <img :src="adviserImage" width="64px" style="border-radius:50%">
                    </a> <b>{{adviserName}}</b>
                  </div>
                  <a href="/counselingDetail"><button class="footerNavi-button button-primary">新しい相談をしてみる</button></a>
                </div>
              </template>
              <template v-else>
                <hr>

                <dl class="item">
                  <dt class="profile-title">返信<span class="must-label">必須</span></dt>
                  <dd class="profile-input">
                    <textarea v-model="replyText" placeholder="返信内容" maxlength="4000"></textarea>
                  </dd>
                  <dd class="profile-textSmall">※診療・処方にあたる回答はできません</dd>
                  <dd class="profile-textSmall">{{replyText.length}} / 4000文字</dd>
                </dl>

                <dl class="item">
                  <dt class="profile-title">関連リンク1</dt>
                  <dd class="profile-input">
                    <div class="profile-input">
                      <input type="text" v-model="replyRelatedLinkUrl1" placeholder="例) https://cancerwith.com/"  />
                    </div>
                  </dd>
                </dl>
                <dl class="item">
                  <dt class="profile-title">関連リンク2</dt>
                  <dd class="profile-input">
                    <div class="profile-input">
                      <input type="text" v-model="replyRelatedLinkUrl2" placeholder="例) https://cancerwith.com/" />
                    </div>
                  </dd>
                </dl>
                <dl class="item">
                  <dt class="profile-title">関連リンク3</dt>
                  <dd class="profile-input">
                    <div class="profile-input">
                      <input type="text" v-model="replyRelatedLinkUrl3" placeholder="例) https://cancerwith.com/" />
                    </div>
                  </dd>
                </dl>
                <dl class="item">
                  <dt class="profile-title">関連リンク4</dt>
                  <dd class="profile-input">
                    <div class="profile-input">
                      <input type="text" v-model="replyRelatedLinkUrl4" placeholder="例) https://cancerwith.com/" />
                    </div>
                  </dd>
                </dl>
                <dl class="item">
                  <dt class="profile-title">関連リンク5</dt>
                  <dd class="profile-input">
                    <div class="profile-input">
                      <input type="text" v-model="replyRelatedLinkUrl5" placeholder="例) https://cancerwith.com/" />
                    </div>
                  </dd>
                </dl>

                <dl class="item">
                  <dt class="profile-title">写真（1枚目）</dt>
                  <dd class="profile-input">
                    <div class="profile-input-image avator-image">
                      <img v-show="uploadedImage1" :src="uploadedImage1" style="max-width:350px"/>
                      <img v-show="!uploadedImage1" style="max-width:350px"/>
                    </div>
                    <div v-show="isUploadImage1Processing" class="loading"></div>
                    <input type="file" @change="upload($event, 1)" id="file1" accept="image/*">
                  </dd>
                </dl>

                <dl class="item" v-if="uploadedImage1">
                  <dt class="profile-title">写真（2枚目）</dt>
                  <dd class="profile-input">
                    <div class="profile-input-image avator-image">
                      <img v-show="uploadedImage2" :src="uploadedImage2" style="max-width:350px"/>
                      <img v-show="!uploadedImage2" style="max-width:350px"/>
                    </div>
                    <div v-show="isUploadImage2Processing" class="loading"></div>
                    <input type="file" @change="upload($event, 2)" id="file2" accept="image/*">
                  </dd>
                </dl>

                <dl class="item" v-if="uploadedImage2">
                  <dt class="profile-title">写真（3枚目）</dt>
                  <dd class="profile-input">
                    <div class="profile-input-image avator-image">
                      <img v-show="uploadedImage3" :src="uploadedImage3" style="max-width:350px"/>
                      <img v-show="!uploadedImage3" style="max-width:350px"/>
                    </div>
                    <div v-show="isUploadImage3Processing" class="loading"></div>
                    <input type="file" @change="upload($event, 3)" id="file3" accept="image/*">
                  </dd>
                </dl>

                <button class="footerNavi-button" v-bind:class="{'button-primary':isActiveButtonPrimary, 'button-disabled':isActiveButtonDisabled}" v-on:click="createCounselingRepliesData()">
                  返信投稿
                </button>
              </template>
            </template>
          </template>
        </div>
        <div v-else>
          <div class="text-box">
            {{loadMessage}}
          </div>
        </div>
      </template>

      <!-- 認証していない時はログイン画面を表示 -->
      <template v-else>
        <LoginItem :createButton="false" />
      </template>
    </main>
    <FooterItem :contactUrl="contactUrl" :hiddenFooterFixedButton="true" />
  </div>
</template>

<script>
import { API, Auth, Storage, graphqlOperation, Analytics, Logger } from "aws-amplify"
//import { AmplifyEventBus } from 'aws-amplify-vue'
import HeaderItem from './Header'
import FooterItem from './Footer'
import LoginItem from './Login'

import { getUser } from "./graphql/queries"
import { listStaffAllowListsBySpecificUser } from './graphql/queries'
import { listUsersBySpecificUser } from "./graphql/queries"
import { listCounselingRepliesBySpecificCounselingTopicsId } from "./graphql/queries"
import { getCounselingTopics } from "./graphql/queries"
import { createCounselingReplies } from "./graphql/mutations"
import { updateCounselingTopics } from "./graphql/mutations"
import { createInformation } from "./graphql/mutations"
import { createMailNotification } from "./graphql/mutations"
import { createErrorLog } from "./graphql/mutations"
import { listCounselingTopicsBySpecificCounselingUserid } from "./graphql/queries"
import { Common } from './Common.js'
import { onAuthUIStateChange } from '@aws-amplify/ui-components';

const logger = new Logger('CounselingDetail');
//window.LOG_LEVEL = 'VERBOSE'
//logger.info('info bar');
//logger.debug('debug bar');
//logger.warn('warn bar');
//logger.error('error bar');
Analytics.autoTrack('pageView', {
  enable: true,
  eventName: 'pageView',
  type: 'multiPageApp',
  provider: 'AWSPinpoint',
  getUrl: () => {
    return window.location.origin + window.location.pathname;
  }
});

export default {
  name: 'counselingDetail',
  components : {
    HeaderItem,
    FooterItem,
    LoginItem
  },
  mixins:[Common],
  data(){
    return{
      authState: undefined,
      unsubscribeAuth: undefined,
      signedIn: false,
      id: '',
      mailaddress: '',
      userType: '',
      isAdviser: false,
      isStaff: false,
      hasUserData: false,
      counselingCategory1: '',
      counselingCategory2: '',
      counselingText: '',
      imageUrl1: '',
      imageUrl2: '',
      imageUrl3: '',
      uploadedImage1: '',
      uploadedImage2: '',
      uploadedImage3: '',
      responseEstimatedDate: '',
      counselingRepliedData: [],
      counselingRepliedCount: 0,
      gender: '',
      relationship: '',
      cancerType: '',
      cancerStage: '',
      diagnosedReason: '',
      diagnosedDate: '',
      hospitalName: '',
      curativeStatus: '',
      cancerHistory: '',
      replyText: '',
      replyRelatedLinkUrl1: '',
      replyRelatedLinkUrl2: '',
      replyRelatedLinkUrl3: '',
      replyRelatedLinkUrl4: '',
      replyRelatedLinkUrl5: '',
      isOwnTopics: false,
      identityId: '',
      lastResponseReplierType: '',
      lastResponseReplierUserid: '',
      ratingsUrl: '',
      violationReportsUrl: '',
      contactUrl: '',
      repliedUserIds: [],
      loadMessage: null,
      showProfile: false,
      showImage: false,
      showPastCounseling: false,
      overlayImageUrl: '',
      counselingUserData: [],
      relatedLinkUrl1: '',
      relatedLinkUrl2: '',
      relatedLinkUrl3: '',
      relatedLinkUrl4: '',
      relatedLinkUrl5: '',
      pastCounselingData: [],
      isLoading: true,
      isUploadImage1Processing: false,
      isUploadImage2Processing: false,
      isUploadImage3Processing: false,
      isReplyLoading: true,
      isActiveButtonPrimary: true,
      isActiveButtonDisabled: false,
      isPostProcessing: false,
      isActiveButtonSecondary: true,
      isActiveSecondButtonDisabled: false,
      isChangeSolvedStatusProcessing: false,
      paymentMode: '',
      paymentCustomerId: '',
      paymentSubscriptionStatus: '',
      paymentSubscriptionStartAt: '',
      paymentSubscriptionEndAt: '',
      paymentActiveStatus: false,
      adviserName: '',
      adviserLink: '',
      adviserImage: '',
    }
  },
  
  filters: {
    truncate: function (value) {
      var length = 50
      var ommision = '...'
      value = value.replace(/<br\s?\/?>/g, ' ')
      if (value.length <= length) {
        return value
      }
      return value.substring(0, length) + ommision
    },
    decodeURI: function (url) {
      return decodeURI(url)
    },
    date: function (value, opt) {
      if (value && opt === 'responseEstimatedDate') {
        var regex1 = /:\d\d\+09:00/gi
        var regex2 = /:\d\d\.\d+Z/gi
        var regex3 = /\+09:00/gi
        return value.replace('T', ' ').replace(regex1, '').replace(regex2, '').replace(regex3, '')
      } else if (value) {
        var valueDate = new Date(value)
        var valueFormat = 'YYYY-MM-DD HH:mm'
        valueFormat = valueFormat.replace(/YYYY/, valueDate.getFullYear())
        
        if (valueDate.getMonth() + 1 < 10) {
          valueFormat = valueFormat.replace(/MM/, '0' + (valueDate.getMonth() + 1))
        } else {
          valueFormat = valueFormat.replace(/MM/, valueDate.getMonth() + 1)
        }
        
        if (valueDate.getDate() < 10) {
          valueFormat = valueFormat.replace(/DD/, '0' + valueDate.getDate())
        } else {
          valueFormat = valueFormat.replace(/DD/, valueDate.getDate())
        }

        if (valueDate.getHours() < 10) {
          valueFormat = valueFormat.replace(/HH/, '0' + valueDate.getHours())
        } else {
          valueFormat = valueFormat.replace(/HH/, valueDate.getHours())
        }

        if (valueDate.getMinutes() < 10) {
          valueFormat = valueFormat.replace(/mm/, '0' + valueDate.getMinutes())
        } else {
          valueFormat = valueFormat.replace(/mm/, valueDate.getMinutes())
        }
        
        return valueFormat
      }
    }
  },
  
  created () {
    this.refresh()
  },
  
  methods: {
    refresh () {
      Storage.list('')
        .then(result => 
          this.s3Data = JSON.parse(JSON.stringify(result))
        )
        .catch(err => {
          logger.error(err)
          Analytics.record({
            name: 'errorLog', 
            attributes: { 
              page: 'CounselingDetail',
              url: window.location.origin + window.location.pathname,
              userid: this.id,
              userType: this.userType,
              counselingTopicsId: this.counselingId,
              errorType: 'Image List : Storage.list',
              errorNumber: 'CounselingDetail-01',
              errorMessage: err
            }
          });

          const errorLog = {
            type: 'errorLog',
            page: 'CounselingDetail',
            url: window.location.origin + window.location.pathname,
            userid: this.id,
            userType: this.userType,
            counselingTopicsId: this.counselingId,
            errorType: 'Image List : Storage.list',
            errorNumber: 'CounselingDetail-01',
            errorMessage: err,
            addUser: 'system',
            createAt: new Date()
          }
          API.graphql(graphqlOperation(
            createErrorLog, { input: errorLog }
          ))
          //alert(err)
        });
    },

    // 画像アップロード
    upload(e, num) {
      this.isPostProcessing = true
      this.isActiveButtonPrimary = false
      this.isActiveButtonDisabled = true
      if (num === 1) {
        this.isUploadImage1Processing = true
      } else if (num === 2) {
        this.isUploadImage2Processing = true
      } else if (num === 3) {
        this.isUploadImage3Processing = true
      }

      var files = e.target.files || e.dataTransfer.files
      var filename = this.id + "-replyImage-" + this.counselingTopicsId + "-" + num + new Date().getTime().toString(16)  + Math.floor(1000 * Math.random()).toString(16) + "-" + files[0].name
      Storage.put(filename, files[0], {
          level: 'protected'
        })
        .then(result => {
          //console.log(result)
          //alert(result)

          if (num === 1) {
            this.replyImageKey1 = result['key']
            this.replyimageUploadedIdentityId1 = this.identityId
          } else if (num === 2) {
            this.replyImageKey2 = result['key']
            this.replyimageUploadedIdentityId2 = this.identityId
          } else if (num === 3) {
            this.replyImageKey3 = result['key']
            this.replyimageUploadedIdentityId3 = this.identityId
          }
          this.download(result['key'], num, '', null, null)
          this.refresh()
          this.isUploadImage1Processing = false
          this.isUploadImage2Processing = false
          this.isUploadImage3Processing = false
          this.isPostProcessing = false
          this.isActiveButtonPrimary = true
          this.isActiveButtonDisabled = false
        })
        .catch(err => {
          logger.error(err)
          Analytics.record({
            name: 'errorLog', 
            attributes: { 
              page: 'CounselingDetail',
              url: window.location.origin + window.location.pathname,
              userid: this.id,
              userType: this.userType,
              counselingTopicsId: this.counselingId,
              errorType: 'Image upload : Storage.put',
              errorNumber: 'CounselingDetail-02',
              errorMessage: err
            }
          });

          const errorLog = {
            type: 'errorLog',
            page: 'CounselingDetail',
            url: window.location.origin + window.location.pathname,
            userid: this.id,
            userType: this.userType,
            counselingTopicsId: this.counselingId,
            errorType: 'Image upload : Storage.put',
            errorNumber: 'CounselingDetail-02',
            errorMessage: err,
            addUser: 'system',
            createAt: new Date()
          }
          API.graphql(graphqlOperation(
            createErrorLog, { input: errorLog }
          ))
          //alert(err)
          this.isUploadImage1Processing = false
          this.isUploadImage2Processing = false
          this.isUploadImage3Processing = false
          this.isPostProcessing = false
          this.isActiveButtonPrimary = true
          this.isActiveButtonDisabled = false
          alert("画像のアップロードに失敗しました")
        })
    },
    download(key, num, type, i, identityId) {
      Storage.get(key, { level: 'protected', identityId: identityId })
        .then(result => {
          //console.log(result)
          
          if (!key) {
            result = null
          }
          if (type === 'topics') {
            if (num === 1) {
              this.imageUrl1 = result
            } else if (num === 2) {
              this.imageUrl2 = result
            } else if (num === 3) {
              this.imageUrl3 = result
            }
          } else if (type === 'getUrl' && result) {
            if (num === 1) {
              this.counselingRepliedData[i].imageUrl1 = result
            } else if (num === 2) {
              this.counselingRepliedData[i].imageUrl2 = result
            } else if (num === 3) {
              this.counselingRepliedData[i].imageUrl3 = result
            }
          } else if (type === 'icon' && result) {
            var tmpData = this.counselingRepliedData[i]
            tmpData.iconUrl = result
            this.counselingRepliedData.splice(i, 1, tmpData)
          } else if (type === 'main' && result) {
            this.counselingUserData.iconUrl = result
          } else {
            if (num === 1) {
              this.uploadedImage1 = result
            } else if (num === 2) {
              this.uploadedImage2 = result
            } else if (num === 3) {
              this.uploadedImage3 = result
            }
          }
        })
        .catch(err => {
          logger.error(err)
          Analytics.record({
            name: 'errorLog', 
            attributes: { 
              page: 'CounselingDetail',
              url: window.location.origin + window.location.pathname,
              userid: this.id,
              userType: this.userType,
              counselingTopicsId: this.counselingId,
              errorType: 'Image download : Storage.get',
              errorNumber: 'CounselingDetail-03',
              errorMessage: err
            }
          });

          const errorLog = {
            type: 'errorLog',
            page: 'CounselingDetail',
            url: window.location.origin + window.location.pathname,
            userid: this.id,
            userType: this.userType,
            counselingTopicsId: this.counselingId,
            errorType: 'Image download : Storage.get',
            errorNumber: 'CounselingDetail-03',
            errorMessage: err,
            addUser: 'system',
            createAt: new Date()
          }
          API.graphql(graphqlOperation(
            createErrorLog, { input: errorLog }
          ))
          //alert(err)
          alert("画像の取得処理に失敗しました")
        })
    },


    // コメント保存
    createCounselingRepliesData: async function () {
      if (!this.isPostProcessing) {
        this.isPostProcessing = true
        this.isActiveButtonPrimary = false
        this.isActiveButtonDisabled = true
        
        // 必須項目チェック
        let errorMessage = ""
        if (!this.replyText) {
          errorMessage += "【返信内容】が未入力です\n"
        }

        // URLエンコード
        this.replyRelatedLinkUrl1 = encodeURI(this.replyRelatedLinkUrl1)
        this.replyRelatedLinkUrl2 = encodeURI(this.replyRelatedLinkUrl2)
        this.replyRelatedLinkUrl3 = encodeURI(this.replyRelatedLinkUrl3)
        this.replyRelatedLinkUrl4 = encodeURI(this.replyRelatedLinkUrl4)
        this.replyRelatedLinkUrl5 = encodeURI(this.replyRelatedLinkUrl5)

        // 関連リンクのURLチェック
        if (this.replyRelatedLinkUrl1) {
          if (!(this.replyRelatedLinkUrl1.startsWith('http://') || this.replyRelatedLinkUrl1.startsWith('https://'))) {
            errorMessage += "【関連リンク1】の形式が不正です\n"
          }
        }
        if (this.replyRelatedLinkUrl2) {
          if (!(this.replyRelatedLinkUrl2.startsWith('http://') || this.replyRelatedLinkUrl2.startsWith('https://'))) {
            errorMessage += "【関連リンク2】の形式が不正です\n"
          }
        }
        if (this.replyRelatedLinkUrl3) {
          if (!(this.replyRelatedLinkUrl3.startsWith('http://') || this.replyRelatedLinkUrl3.startsWith('https://'))) {
            errorMessage += "【関連リンク3】の形式が不正です\n"
          }
        }
        if (this.replyRelatedLinkUrl4) {
          if (!(this.replyRelatedLinkUrl4.startsWith('http://') || this.replyRelatedLinkUrl4.startsWith('https://'))) {
            errorMessage += "【関連リンク4】の形式が不正です\n"
          }
        }
        if (this.replyRelatedLinkUrl5) {
          if (!(this.replyRelatedLinkUrl5.startsWith('http://') || this.replyRelatedLinkUrl5.startsWith('https://'))) {
            errorMessage += "【関連リンク5】の形式が不正です\n"
          }
        }

        if (errorMessage.length > 0) {
          this.isActiveButtonPrimary = true
          this.isActiveButtonDisabled = false
          this.isPostProcessing = false
          alert("保存に失敗しました\n\n" + errorMessage)
          return
        }

        let createAt = new Date()
        const counselingRepliesData = {
          type: 'counselingReplies',
          //id: null,
          counselingTopicsId: this.counselingId,
          replierType: this.userType,
          replierUserid: this.id,
          replyText: this.replyText,
          imageKey1: this.replyImageKey1,
          imageKey2: this.replyImageKey2,
          imageKey3: this.replyImageKey3,
          imageUploadedIdentityId1: this.replyimageUploadedIdentityId1,
          imageUploadedIdentityId2: this.replyimageUploadedIdentityId2,
          imageUploadedIdentityId3: this.replyimageUploadedIdentityId3,
          createAt: createAt,
          updateAt: createAt
        }
        if (this.replyRelatedLinkUrl1) {
          counselingRepliesData.relatedLinkUrl1 = this.replyRelatedLinkUrl1
        }
        if (this.replyRelatedLinkUrl2) {
          counselingRepliesData.relatedLinkUrl2 = this.replyRelatedLinkUrl2
        }
        if (this.replyRelatedLinkUrl3) {
          counselingRepliesData.relatedLinkUrl3 = this.replyRelatedLinkUrl3
        }
        if (this.replyRelatedLinkUrl4) {
          counselingRepliesData.relatedLinkUrl4 = this.replyRelatedLinkUrl4
        }
        if (this.replyRelatedLinkUrl5) {
          counselingRepliesData.relatedLinkUrl5 = this.replyRelatedLinkUrl5
        }

        var nowDate = new Date()
        var i = 2 // 待つ日数
        try {
          await API.graphql(graphqlOperation(
            createCounselingReplies, { input: counselingRepliesData }
          ))
          var serviceName = this.getServiceName(location.hostname)


          // お知らせを回答したことのあるアドバイザー/投稿者向けに登録
          var notificationTargetGroup = ''
          var notificationTargetDetail = ''
          var notificationText = ''
          var mailNotificationSubject = ''
          var mailNotificationMessage = ''
          var d = new Date()
          var nowYear = d.getFullYear()
          if (this.isAdviser) {
            notificationTargetGroup = 'user'
            notificationTargetDetail = this.counselingUserid
            notificationText = '相談にアドバイザーから回答がありました。内容を確認してください。'
            mailNotificationSubject = '【' + serviceName + '】アドバイザーから回答がありました'
            mailNotificationMessage = "いつも" + serviceName + "をご利用いただきありがとうございます。\n\nアドバイザーより相談への回答がありました。\n"
                                  + "以下のURLから内容をご確認ください。\n" + location.href + "\n\n"
                                  + "-----\n※本メールは送信専用のメールアドレスから自動配信しています。\n※運営にお問い合わせいただく際は、support@cancerwith.com までご連絡ください。\n\n"
                                  + "Copyright (C) " + nowYear + " ZINE INC. All Rights Reserved."

          } else {
            notificationTargetGroup = 'adviser'
            notificationTargetDetail = this.repliedUserIds
            notificationText = 'あなたが回答した相談に、相談者から追加の回答がありました。内容を確認してください。'
            mailNotificationSubject = '【' + serviceName + '】相談者から回答がありました'
            mailNotificationMessage = "いつも" + serviceName + "をご利用いただきありがとうございます。\n\n相談者より回答がありました。\n"
                                  + "以下のURLから内容をご確認ください。\n" + location.href + "\n\n"
                                  + "-----\n※本メールは送信専用のメールアドレスから自動配信しています。\n※運営にお問い合わせいただく際は、support@cancerwith.com までご連絡ください。\n\n"
                                  + "Copyright (C) " + nowYear + " ZINE INC. All Rights Reserved."

            // ID重複排除
            notificationTargetDetail = Array.from(new Set(notificationTargetDetail))

            // 投稿者自身を排除
            let counselingUseridIndex = notificationTargetDetail.indexOf(this.counselingUserid)
            if (counselingUseridIndex >= 0) {
              notificationTargetDetail.splice(counselingUseridIndex, 1)
            }
          }


          var notificationStartDate = new Date(nowDate.getTime() + 9*60*60*1000)
          var notificationEndDate = new Date(nowDate.getTime() + i*24*60*60*1000 + 9*60*60*1000)
          const informationData = {
            type: 'information',
            id: nowDate.getTime() + '-' + this.counselingId,
            notificationTargetGroup: notificationTargetGroup,
            notificationTargetDetail: JSON.stringify(notificationTargetDetail),
            notificationText: notificationText,
            notificationUrl: location.href,
            notificationStartDate: notificationStartDate.getUTCFullYear() + '-'
                                    + ('0' + (notificationStartDate.getUTCMonth() + 1)).slice(-2) + '-'
                                    + ('0' + notificationStartDate.getUTCDate()).slice(-2) + 'T'
                                    + ('0' + notificationStartDate.getUTCHours()).slice(-2) + ':'
                                    + ('0' + notificationStartDate.getUTCMinutes()).slice(-2) + ':'
                                    + ('0' + notificationStartDate.getUTCSeconds()).slice(-2)
                                    + '+09:00',
            notificationEndDate: notificationEndDate.getUTCFullYear() + '-'
                                    + ('0' + (notificationEndDate.getUTCMonth() + 1)).slice(-2) + '-'
                                    + ('0' + notificationEndDate.getUTCDate()).slice(-2) + 'T'
                                    + ('0' + notificationEndDate.getUTCHours()).slice(-2) + ':'
                                    + ('0' + notificationEndDate.getUTCMinutes()).slice(-2) + ':'
                                    + ('0' + notificationEndDate.getUTCSeconds()).slice(-2)
                                    + '+09:00',   // 2日後に掲載終了
            notificationType: '新規回答のお知らせ',
            addUser: 'system',
            createAt: createAt,
            updateAt: createAt
          }

          try {
            await API.graphql(graphqlOperation(
              createInformation, { input: informationData }
            ))

            // メール通知
            let mailNotificationTargetDetail = []
            if (this.isAdviser) {
              mailNotificationTargetDetail[0] = notificationTargetDetail
            } else {
              mailNotificationTargetDetail = notificationTargetDetail
            }

            // Slack #adviser_notice への通知のための宛先を追加
            // 本番以外 #dev_adviser_notice への通知
            var devNoticeAdviserChannel = 'dev_adviser_notice-aaaaejkg6tbtfodmqbdukh4bee@zine-inc.slack.com'
            // 本番 #adviser_notice への通知
            var prodNoticeAdviserChannel = 'adviser_notice-aaaaejhnjjaimvp7sfvcxnkh4i@zine-inc.slack.com'

            var noticeAdviserChannel = ''
            if (location.hostname === 'dev.d2q78m2xs8yfz1.amplifyapp.com' || location.hostname === 'localhost') {
              noticeAdviserChannel = devNoticeAdviserChannel
            } else if (location.hostname.match(/^feature-.*\.d2q78m2xs8yfz1\.amplifyapp\.com$/)) {
              noticeAdviserChannel = devNoticeAdviserChannel
            } else if (location.hostname === 'design.d2q78m2xs8yfz1.amplifyapp.com') {
              noticeAdviserChannel = devNoticeAdviserChannel
            } else if (location.hostname === 'staging.d2q78m2xs8yfz1.amplifyapp.com') {
              noticeAdviserChannel = devNoticeAdviserChannel
            } else if (location.hostname === 'payment.d2q78m2xs8yfz1.amplifyapp.com') {
              noticeAdviserChannel = devNoticeAdviserChannel
            } else {
              noticeAdviserChannel = prodNoticeAdviserChannel
            }

            // アドバイザー情報に通知用のデータを追加
            var adviserTmpDataForSlackNotice = {
              type : 'notice',
              mailAddress : noticeAdviserChannel
            }
            mailNotificationTargetDetail.push(adviserTmpDataForSlackNotice)

            for (let key in mailNotificationTargetDetail) {
              let targetUserid = mailNotificationTargetDetail[key]
              let targetMailAddress = ''

              // UserIDからメールアドレスを取得（noticeの通知以外）
              if (! mailNotificationTargetDetail[key].type) {
                let userData = await API.graphql(graphqlOperation(
                  getUser, {id:  targetUserid, limit: 1}
                ))
                targetMailAddress = userData.data.getUser.mailAddress
              } else {
                targetUserid = mailNotificationTargetDetail[key].type
                targetMailAddress = mailNotificationTargetDetail[key].mailAddress
              }

              // アドバイザー分ループして全アドバイザー個別にレコード追加
              let mailNotificationData = {
                type: 'mailNotification',
                targetUserid: targetUserid,
                mailAddress: targetMailAddress,
                subject: mailNotificationSubject,
                message: mailNotificationMessage,
                addUser: 'system',
                createAt: createAt,
                isNeededBackupBcc: true,
                isNeededAsanaForward: false
              }

              try {
                await API.graphql(graphqlOperation(
                  createMailNotification, { input: mailNotificationData }
                ))
              } catch (error) {
                logger.error(JSON.stringify(error))
                Analytics.record({
                  name: 'errorLog',
                  attributes: {
                    page: 'CounselingDetail',
                    url: window.location.origin + window.location.pathname,
                    userid: this.id,
                    userType: this.userType,
                    counselingTopicsId: this.counselingId,
                    errorType: 'MainNotification Create : createMailNotification',
                    errorNumber: 'CounselingDetail-08',
                    errorMessage: JSON.stringify(error)
                  }
                });

                let errorLog = {
                  type: 'errorLog',
                  page: 'CounselingDetail',
                  url: window.location.origin + window.location.pathname,
                  userid: this.id,
                  userType: this.userType,
                  counselingTopicsId: this.counselingId,
                  errorType: 'MainNotification Create : createMailNotification',
                  errorNumber: 'CounselingDetail-08',
                  errorMessage: JSON.stringify(error),
                  addUser: 'system',
                  createAt: new Date()
                }
                await API.graphql(graphqlOperation(
                  createErrorLog, { input: errorLog }
                ))
              }
            }

            // 新規返信内容のパトロール用のAsana転送用通知
            const mailNotificationDataForAsanaForward = {
              type: 'mailNotification',
              targetUserid: this.id,
              mailAddress: 'ikeda+CancerWithAsanaForward@zineinc.co.jp',
              subject: mailNotificationSubject + ' - 相談ID : ' + this.counselingId + ', UserID : ' + this.id + ' ' + location.href,
              message: mailNotificationMessage,
              addUser: 'system',
              createAt: createAt,
              isNeededBackupBcc: false,
              isNeededAsanaForward: true
            }
            await API.graphql(graphqlOperation(
              createMailNotification, { input: mailNotificationDataForAsanaForward }
            ))

            var responseEstimatedDate = new Date(nowDate.getTime() + i*24*60*60*1000)

            const counselingTopicsData = {
              type: 'counselingTopics',
              id: this.counselingId,
              counselingCategory1: this.counselingCategory1,
              counselingCategory2: this.counselingCategory2,
              counselingText: this.counselingText,
              imageKey1: this.imageKey1,
              imageKey2: this.imageKey2,
              imageKey3: this.imageKey3,
              imageUploadedIdentityId1: this.imageUploadedIdentityId1,
              imageUploadedIdentityId2: this.imageUploadedIdentityId2,
              imageUploadedIdentityId3: this.imageUploadedIdentityId3,
              counselingUserid: this.counselingUserid,
              responseEstimatedDate: responseEstimatedDate.getUTCFullYear() + '-'
                                      + ('0' + (responseEstimatedDate.getUTCMonth() + 1)).slice(-2) + '-'
                                      + ('0' + responseEstimatedDate.getUTCDate()).slice(-2)
                                      + '+09:00',
              lastResponseDate: this.lastResponseDate,
              lastResponseReplierType: this.userType,
              lastResponseReplierUserid: this.id,
              status: this.status,
              responseStatus: this.responseStatus,
              createAt: this.createAtForSave,
              updateAt: new Date()
            }
            if (this.relatedLinkUrl1) {
              counselingTopicsData.relatedLinkUrl1 = this.relatedLinkUrl1
            }
            if (this.relatedLinkUrl2) {
              counselingTopicsData.relatedLinkUrl2 = this.relatedLinkUrl2
            }
            if (this.relatedLinkUrl3) {
              counselingTopicsData.relatedLinkUrl3 = this.relatedLinkUrl3
            }
            if (this.relatedLinkUrl4) {
              counselingTopicsData.relatedLinkUrl4 = this.relatedLinkUrl4
            }
            if (this.relatedLinkUrl5) {
              counselingTopicsData.relatedLinkUrl5 = this.relatedLinkUrl5
            }

            try {
              await API.graphql(graphqlOperation(
                updateCounselingTopics, { input: counselingTopicsData }
              ))

              alert("投稿しました")
              
              // すべての処理が完了したらリロード
              location.reload(true)
            } catch (error) {
              logger.error(JSON.stringify(error))
              Analytics.record({
                name: 'errorLog', 
                attributes: { 
                  page: 'CounselingDetail',
                  url: window.location.origin + window.location.pathname,
                  userid: this.id,
                  userType: this.userType,
                  counselingTopicsId: this.counselingId,
                  errorType: 'counselingTopics update : updateCounselingTopics',
                  errorNumber: 'CounselingDetail-04',
                  errorMessage: JSON.stringify(error)
                }
              });

              const errorLog = {
                type: 'errorLog',
                page: 'CounselingDetail',
                url: window.location.origin + window.location.pathname,
                userid: this.id,
                userType: this.userType,
                counselingTopicsId: this.counselingId,
                errorType: 'counselingTopics update : updateCounselingTopics',
                errorNumber: 'CounselingDetail-04',
                errorMessage: JSON.stringify(error),
                addUser: 'system',
                createAt: new Date()
              }
              await API.graphql(graphqlOperation(
                createErrorLog, { input: errorLog }
              ))
              this.isActiveButtonPrimary = true
              this.isActiveButtonDisabled = false
              this.isPostProcessing = false
              alert("投稿に失敗しました")
            }
          } catch (error) {
            logger.error(JSON.stringify(error))
            Analytics.record({
              name: 'errorLog', 
              attributes: { 
                page: 'CounselingDetail',
                url: window.location.origin + window.location.pathname,
                userid: this.id,
                userType: this.userType,
                counselingTopicsId: this.counselingId,
                errorType: 'counselingTopics update : createInformation and updateCounselingTopics',
                errorNumber: 'CounselingDetail-05',
                errorMessage: JSON.stringify(error)
              }
            });

            const errorLog = {
              type: 'errorLog',
              page: 'CounselingDetail',
              url: window.location.origin + window.location.pathname,
              userid: this.id,
              userType: this.userType,
              counselingTopicsId: this.counselingId,
              errorType: 'counselingTopics update : createInformation and updateCounselingTopics',
              errorNumber: 'CounselingDetail-05',
              errorMessage: JSON.stringify(error),
              addUser: 'system',
              createAt: new Date()
            }
            await API.graphql(graphqlOperation(
              createErrorLog, { input: errorLog }
            ))
          }

        } catch (error) {
          logger.error(JSON.stringify(error))
          Analytics.record({
            name: 'errorLog', 
            attributes: { 
              page: 'CounselingDetail',
              url: window.location.origin + window.location.pathname,
              userid: this.id,
              userType: this.userType,
              counselingTopicsId: this.counselingId,
              errorType: 'counselingTopics update : createCounselingReplies, createInformation and updateCounselingTopics',
              errorNumber: 'CounselingDetail-06',
              errorMessage: JSON.stringify(error)
            }
          });

          const errorLog = {
            type: 'errorLog',
            page: 'CounselingDetail',
            url: window.location.origin + window.location.pathname,
            userid: this.id,
            userType: this.userType,
            counselingTopicsId: this.counselingId,
            errorType: 'counselingTopics update : createCounselingReplies, createInformation and updateCounselingTopics',
            errorNumber: 'CounselingDetail-06',
            errorMessage: JSON.stringify(error),
            addUser: 'system',
            createAt: new Date()
          }
          await API.graphql(graphqlOperation(
            createErrorLog, { input: errorLog }
          ))
          //alert(error)
          this.isActiveButtonPrimary = true
          this.isActiveButtonDisabled = false
          this.isPostProcessing = false
          alert("保存に失敗しました\n未入力項目がないか確認してください")
        }
      }
    },

    // 解決ステータスの変更
    changeSolvedStatus: async function (status) {
      if (!this.isChangeSolvedStatusProcessing) {
        this.isChangeSolvedStatusProcessing = true
        this.isActiveButtonSecondary = false
        this.isActiveSecondButtonDisabled = true

        var statusLabel = '相談中'
        var beforeStatusLabel = '解決済み'
        if (status) {
          statusLabel = '解決済み'
          beforeStatusLabel = '相談中'
        }
        const counselingTopicsData = {
          type: 'counselingTopics',
          id: this.counselingId,
          counselingCategory1: this.counselingCategory1,
          counselingCategory2: this.counselingCategory2,
          counselingText: this.counselingText,
          imageKey1: this.imageKey1,
          imageKey2: this.imageKey2,
          imageKey3: this.imageKey3,
          imageUploadedIdentityId1: this.imageUploadedIdentityId1,
          imageUploadedIdentityId2: this.imageUploadedIdentityId2,
          imageUploadedIdentityId3: this.imageUploadedIdentityId3,
          counselingUserid: this.counselingUserid,
          responseEstimatedDate: this.responseEstimatedDate,
          lastResponseDate: this.lastResponseDate,
          status: statusLabel,
          responseStatus: this.responseStatus,
          createAt: this.createAtForSave,
          updateAt: new Date()
        }
        if (this.relatedLinkUrl1) {
          counselingTopicsData.relatedLinkUrl1 = this.relatedLinkUrl1
        }
        if (this.relatedLinkUrl2) {
          counselingTopicsData.relatedLinkUrl2 = this.relatedLinkUrl2
        }
        if (this.relatedLinkUrl3) {
          counselingTopicsData.relatedLinkUrl3 = this.relatedLinkUrl3
        }
        if (this.relatedLinkUrl4) {
          counselingTopicsData.relatedLinkUrl4 = this.relatedLinkUrl4
        }
        if (this.relatedLinkUrl5) {
          counselingTopicsData.relatedLinkUrl5 = this.relatedLinkUrl5
        }

        try {
          await API.graphql(graphqlOperation(
            updateCounselingTopics, { input: counselingTopicsData }
          ))

          // メール通知
          var d = new Date()
          var nowYear = d.getFullYear()
          var ratingsMessage = ''
          if (status) {
            ratingsMessage = "今回の相談について評価をお願いします。\n"
                  + this.ratingsUrl + "\n\n"
          }
          var serviceName = this.getServiceName(location.hostname)

          const mailNotificationData = {
            type: 'mailNotification',
            targetUserid: this.counselingUserid,
            mailAddress: this.mailaddress,
            subject: '【' + serviceName + '】相談のステータスが「' + statusLabel + '」に変更されました',
            message: "いつも" + serviceName + "をご利用いただきありがとうございます。\n\nあなたの相談のステータスが「" + beforeStatusLabel + "」から「" + statusLabel + "」に変更されました。\n" + window.location.origin + window.location.pathname + "\n\n"
                  + ratingsMessage
                  + "過去の相談はいつでも解決・再開の切り替えが可能です。\n"
                  + "一度解決した相談でも、再度気になることがありましたら、相談を再開してください。\n\n"
                  + "-----\n※本メールは送信専用のメールアドレスから自動配信しています。\n※運営にお問い合わせいただく際は、support@cancerwith.com までご連絡ください。\n\n"
                  + "Copyright (C) " + nowYear + " ZINE INC. All Rights Reserved.",
            addUser: 'system',
            createAt: d,
            isNeededBackupBcc: true,
            isNeededAsanaForward: false
          }
          await API.graphql(graphqlOperation(
            createMailNotification, { input: mailNotificationData }
          ))


          // 返信履歴のあるアドバイザー向けメール通知
          let mailNotificationTargetDetail = this.repliedUserIds

          // ID重複排除
          mailNotificationTargetDetail = Array.from(new Set(mailNotificationTargetDetail))


          // 投稿者自身を排除
          let counselingUseridIndex = mailNotificationTargetDetail.indexOf(this.counselingUserid)
          if (counselingUseridIndex >= 0) {
            mailNotificationTargetDetail.splice(counselingUseridIndex, 1)
          }

          for (let key in mailNotificationTargetDetail) {
            let targetUserid = mailNotificationTargetDetail[key]

            // UserIDからメールアドレスを取得
            let userData = await API.graphql(graphqlOperation(
              getUser, {id:  targetUserid, limit: 1}
            ))
            let targetMailAddress = userData.data.getUser.mailAddress

            ratingsMessage = ''
            if (status) {
              ratingsMessage = "今回の相談について評価をお願いします。\n"
                    + 'https://share.hsforms.com/1mIbXgocbTk2Smr1CzKoDHg46sq5?cancerwith_userid=' + targetUserid + '&cancerwith_counseling_topics_id=' + this.counselingId + '&cancerwith_env=' + this.getEnv(location.hostname)
                    + "\n\n"
            }

            let mailAdviserNotificationData = {
              type: 'mailNotification',
              targetUserid: targetUserid,
              mailAddress: targetMailAddress,
              subject: '【' + serviceName + '】返信済みの相談のステータスが「' + statusLabel + '」に変更されました',
              message: "いつも" + serviceName + "をご利用いただきありがとうございます。\n\nあなたが返信済みの相談のステータスが「" + beforeStatusLabel + "」から「" + statusLabel + "」に変更されました。\n" + window.location.origin + window.location.pathname + "\n\n"
                    + ratingsMessage
                    + "-----\n※本メールは送信専用のメールアドレスから自動配信しています。\n※運営にお問い合わせいただく際は、support@cancerwith.com までご連絡ください。\n\n"
                    + "Copyright (C) " + nowYear + " ZINE INC. All Rights Reserved.",
              addUser: 'system',
              createAt: d,
              isNeededBackupBcc: true,
              isNeededAsanaForward: false
            }
            await API.graphql(graphqlOperation(
              createMailNotification, { input: mailAdviserNotificationData }
            ))
          }

          this.isChangeSolvedStatusProcessing = false
          this.isActiveButtonSecondary = true
          this.isActiveSecondButtonDisabled = false
          alert("ステータスを変更しました")
          location.reload(true)
        } catch (error) {
          logger.error(JSON.stringify(error))
          Analytics.record({
            name: 'errorLog', 
            attributes: { 
              page: 'CounselingDetail',
              url: window.location.origin + window.location.pathname,
              userid: this.id,
              userType: this.userType,
              counselingTopicsId: this.counselingId,
              errorType: 'changeSolvedStatus : updateCounselingTopics',
              errorNumber: 'CounselingDetail-07',
              errorMessage: JSON.stringify(error)
            }
          });

          const errorLog = {
            type: 'errorLog',
            page: 'CounselingDetail',
            url: window.location.origin + window.location.pathname,
            userid: this.id,
            userType: this.userType,
            counselingTopicsId: this.counselingId,
            errorType: 'changeSolvedStatus : updateCounselingTopics',
            errorNumber: 'CounselingDetail-07',
            errorMessage: JSON.stringify(error),
            addUser: 'system',
            createAt: new Date()
          }
          await API.graphql(graphqlOperation(
            createErrorLog, { input: errorLog }
          ))
          this.isChangeSolvedStatusProcessing = false
          this.isActiveButtonSecondary = true
          this.isActiveSecondButtonDisabled = false
          alert("ステータスの変更に失敗しました")
        }
      }
    },

    openImage: function(imageUrl) {
      this.overlayImageUrl = imageUrl
      this.showImage = true
    },

    closeImage: function() {
      this.showImage = false
    },

    getAge: function(birthDate) {
      var today = new Date()
      var tdate = ( today.getFullYear() * 10000 ) + (( today.getMonth() + 1 ) * 100 ) + today.getDate()
      var age = Math.floor(( tdate - birthDate.replace(/-/g, '') ) / 10000 )
      return age
    }
  },

  beforeDestroy() {
    this.unsubscribeAuth();
  },

  async beforeCreate() {
    this.unsubscribeAuth = onAuthUIStateChange(async (authState, authData) => {
      this.authState = authState;
      this.user = authData;
      if (authState === 'signedin') {
        let cognitoUser = await Auth.currentAuthenticatedUser()
        this.signedIn = true
        this.id = cognitoUser.username

        // TODO: ここで hasUserData の確認処理をキックし、リロードの要不要を判定
        location.reload(1)
      } else if (authState === 'signedout') {
        // ログアウト前の情報を破棄
        this.$destroy()
        location.reload(1)
      } else {
        this.signedIn = false
      }
    });

    // Auth.currentAuthenticatedUser()でユーザ情報を取得する。
    // 取得できなければ認証ステータスをfalseに設定する
    try {
      let cognitoUser = await Auth.currentAuthenticatedUser()
      this.signedIn = true
      this.id = cognitoUser.username
      this.mailaddress = cognitoUser.attributes.email

      let currentCredentials = await Auth.currentCredentials()
      this.identityId = currentCredentials.identityId
    } catch (err) {
      this.signedIn = false
      this.loadMessage = '権限がありません'
      this.isLoading = false
    }
    
    // 認証情報でUserデータを確認
    try {
      let userData = await API.graphql(graphqlOperation(
        listUsersBySpecificUser, {mailAddress: this.mailaddress, limit: 1}
      ))

      // 課金モードの確認
      this.paymentActiveStatus = this.getPaymentActiveStatus(location.hostname)

      // 支払いステータス
      if (this.paymentActiveStatus) {
        this.paymentCustomerId = userData.data.listUsersBySpecificUser.items[0].paymentCustomerId
        this.paymentSubscriptionStatus = userData.data.listUsersBySpecificUser.items[0].paymentSubscriptionStatus
        this.paymentSubscriptionStartAt = userData.data.listUsersBySpecificUser.items[0].paymentSubscriptionStartAt
        this.paymentSubscriptionEndAt = userData.data.listUsersBySpecificUser.items[0].paymentSubscriptionEndAt
        this.paymentMode = this.getPaymentMode(this.paymentSubscriptionStatus, this.paymentSubscriptionStartAt, this.paymentSubscriptionEndAt)
      }

      this.userId = userData.data.listUsersBySpecificUser.items[0].id
      this.userType = userData.data.listUsersBySpecificUser.items[0].type
      this.gender = userData.data.listUsersBySpecificUser.items[0].gender
      this.relationship = userData.data.listUsersBySpecificUser.items[0].relationship
      this.cancerType = JSON.parse(userData.data.listUsersBySpecificUser.items[0].cancerType).join('、')
      this.cancerStage = userData.data.listUsersBySpecificUser.items[0].cancerStage
      this.diagnosedReason = userData.data.listUsersBySpecificUser.items[0].diagnosedReason
      this.diagnosedDate = userData.data.listUsersBySpecificUser.items[0].diagnosedDate
      this.hospitalName = userData.data.listUsersBySpecificUser.items[0].hospitalName
      this.curativeStatus = userData.data.listUsersBySpecificUser.items[0].curativeStatus
      this.cancerHistory = userData.data.listUsersBySpecificUser.items[0].cancerHistory
      this.consentHamaMEDResearch = userData.data.listUsersBySpecificUser.items[0].consentHamaMEDResearch
      if (userData.data.listUsersBySpecificUser.items[0].type === 'adviser') {
        this.isAdviser = true
      } else {
        this.isAdviser = false
      }
      if (userData.data.listUsersBySpecificUser.items[0].id) {
          this.hasUserData = true 
      }
    } catch (err) {
      // 運営アカウントか判定
      try {
        let staffAllowData = await API.graphql(
          graphqlOperation(listStaffAllowListsBySpecificUser, {
            mailAddress: this.mailaddress,
            limit: 1
          })
        )
        if (
          staffAllowData.data.listStaffAllowListsBySpecificUser.items[0].mailAddress ===
          this.mailaddress
        ) {
          // 運営モード
          this.userId = ''
          this.userType = 'adviser'
          this.isAdviser = false
          this.isStaff = true
          this.hasUserData = true
          this.contactUrl = ''
        } else {
          this.userId = ''
          this.userType = ''
          this.isAdviser = false
          this.isStaff = false
          this.hasUserData = false
          this.contactUrl = ''
        }
      } catch (err) {
        this.userId = ''
        this.userType = ''
        this.isAdviser = false
        this.isStaff = false
        this.hasUserData = false
        this.contactUrl = ''
      }
    }

    // 相談内容取得
    try {
      let counselingTopicsData = await API.graphql(graphqlOperation(
        getCounselingTopics, {id: this.$route.params.counselingTopicsId, limit: 1}
      ))
      this.counselingId = counselingTopicsData.data.getCounselingTopics.id
      this.counselingCategory1 = counselingTopicsData.data.getCounselingTopics.counselingCategory1
      this.counselingCategory2 = counselingTopicsData.data.getCounselingTopics.counselingCategory2
      this.counselingText = counselingTopicsData.data.getCounselingTopics.counselingText.replace(/\r?\n/g, '<br>')
      this.imageUrl1 = this.download(counselingTopicsData.data.getCounselingTopics.imageKey1, 1, 'topics', null, counselingTopicsData.data.getCounselingTopics.imageUploadedIdentityId1)
      this.imageUrl2 = this.download(counselingTopicsData.data.getCounselingTopics.imageKey2, 2, 'topics', null, counselingTopicsData.data.getCounselingTopics.imageUploadedIdentityId2)
      this.imageUrl3 = this.download(counselingTopicsData.data.getCounselingTopics.imageKey3, 3, 'topics', null, counselingTopicsData.data.getCounselingTopics.imageUploadedIdentityId3)
      this.imageKey1 = counselingTopicsData.data.getCounselingTopics.imageKey1
      this.imageKey2 = counselingTopicsData.data.getCounselingTopics.imageKey2
      this.imageKey3 = counselingTopicsData.data.getCounselingTopics.imageKey3
      this.imageUploadedIdentityId1 = counselingTopicsData.data.getCounselingTopics.imageUploadedIdentityId1
      this.imageUploadedIdentityId2 = counselingTopicsData.data.getCounselingTopics.imageUploadedIdentityId2
      this.imageUploadedIdentityId3 = counselingTopicsData.data.getCounselingTopics.imageUploadedIdentityId3
      this.responseEstimatedDate = counselingTopicsData.data.getCounselingTopics.responseEstimatedDate
      this.lastResponseDate = counselingTopicsData.data.getCounselingTopics.lastResponseDate
      this.responseStatus = counselingTopicsData.data.getCounselingTopics.responseStatus
      this.status = counselingTopicsData.data.getCounselingTopics.status
      this.counselingUserid = counselingTopicsData.data.getCounselingTopics.counselingUserid
      this.lastResponseReplierType = counselingTopicsData.data.getCounselingTopics.lastResponseReplierType
      this.lastResponseReplierUserid = counselingTopicsData.data.getCounselingTopics.lastResponseReplierUserid
      this.relatedLinkUrl1 = counselingTopicsData.data.getCounselingTopics.relatedLinkUrl1
      this.relatedLinkUrl2 = counselingTopicsData.data.getCounselingTopics.relatedLinkUrl2
      this.relatedLinkUrl3 = counselingTopicsData.data.getCounselingTopics.relatedLinkUrl3
      this.relatedLinkUrl4 = counselingTopicsData.data.getCounselingTopics.relatedLinkUrl4
      this.relatedLinkUrl5 = counselingTopicsData.data.getCounselingTopics.relatedLinkUrl5
      if (this.status === '解決済み') {
        this.isSolved = true
      } else {
        this.isSolved = false
      }

      var counselingUserid = counselingTopicsData.data.getCounselingTopics.counselingUserid
      if (counselingUserid === this.id) {
        this.isOwnTopics = true
      } else {
        if (this.isAdviser || this.isStaff) {
          this.isOwnTopics = true
        } else {
          this.isOwnTopics = false
          this.loadMessage = '権限がありません'
        }
      }
      
      var createAtDate = new Date(counselingTopicsData.data.getCounselingTopics.createAt)
      var createAtFormat = 'YYYY-MM-DD HH:mm'
      var createAtForSaveFormat = 'YYYY-MM-DDTHH:mm:ss+09:00'
      createAtFormat = createAtFormat.replace(/YYYY/, createAtDate.getFullYear())
      createAtForSaveFormat = createAtForSaveFormat.replace(/YYYY/, createAtDate.getFullYear())
      
      if (createAtDate.getMonth() + 1 < 10) {
        createAtFormat = createAtFormat.replace(/MM/, '0' + (createAtDate.getMonth() + 1))
        createAtForSaveFormat = createAtForSaveFormat.replace(/MM/, '0' + (createAtDate.getMonth() + 1))
      } else {
        createAtFormat = createAtFormat.replace(/MM/, createAtDate.getMonth() + 1)
        createAtForSaveFormat = createAtForSaveFormat.replace(/MM/, createAtDate.getMonth() + 1)
      }
      
      if (createAtDate.getDate() < 10) {
        createAtFormat = createAtFormat.replace(/DD/, '0' + createAtDate.getDate())
        createAtForSaveFormat = createAtForSaveFormat.replace(/DD/, '0' + createAtDate.getDate())
      } else {
        createAtFormat = createAtFormat.replace(/DD/, createAtDate.getDate())
        createAtForSaveFormat = createAtForSaveFormat.replace(/DD/, createAtDate.getDate())
      }

      if (createAtDate.getHours() < 10) {
        createAtFormat = createAtFormat.replace(/HH/, '0' + createAtDate.getHours())
        createAtForSaveFormat = createAtForSaveFormat.replace(/HH/, '0' + createAtDate.getHours())
      } else {
        createAtFormat = createAtFormat.replace(/HH/, createAtDate.getHours())
        createAtForSaveFormat = createAtForSaveFormat.replace(/HH/, createAtDate.getHours())
      }

      if (createAtDate.getMinutes() < 10) {
        createAtFormat = createAtFormat.replace(/mm/, '0' + createAtDate.getMinutes())
        createAtForSaveFormat = createAtForSaveFormat.replace(/mm/, '0' + createAtDate.getMinutes())
      } else {
        createAtFormat = createAtFormat.replace(/mm/, createAtDate.getMinutes())
        createAtForSaveFormat = createAtForSaveFormat.replace(/mm/, createAtDate.getMinutes())
      }
      
      if (createAtDate.getSeconds() < 10) {
        createAtForSaveFormat = createAtForSaveFormat.replace(/ss/, '0' + createAtDate.getSeconds())
      } else {
        createAtForSaveFormat = createAtForSaveFormat.replace(/ss/, createAtDate.getSeconds())
      }

      let env = this.getEnv(location.hostname)
      this.createAt = createAtFormat
      this.createAtForSave = createAtForSaveFormat
      this.violationReportsUrl = 'https://share.hsforms.com/1k2pjF4dGQrmK6uEogF6JCg46sq5?cancerwith_userid=' + this.id + '&cancerwith_counseling_topics_id=' + this.counselingId + '&cancerwith_env=' + env
      this.appClass = this.getAppDivClass(location.hostname)
      if (this.appClass === 'hama') {
        // 浜松オンラインがん相談版
        var formUrl = 'https://share.hsforms.com/1ru_UgBGhS-i3Y7HwUTae4A46sq5' // 研究同意なし
        if (this.consentHamaMEDResearch === 'agree') {
          formUrl = 'https://share.hsforms.com/1yNcTCeHlSGSlr1tKHWPW_w46sq5' // 研究同意あり
        }
        this.ratingsUrl = formUrl + '?cancerwith_userid=' + this.id + '&cancerwith_counseling_topics_id=' + this.counselingId + '&cancerwith_env=' + env
        this.contactUrl = 'https://share.hsforms.com/1qOJQdDxdSbSqrkrMw8jeFA46sq5?cancerwith_userid=' + this.id + '&cancerwith_counseling_topics_id=' + this.counselingId + '&cancerwith_env=' + env
      } else {
        // CancerWith版
        this.ratingsUrl = 'https://share.hsforms.com/1b7et-QcsSbqn0irkqmvE5Q46sq5?cancerwith_userid=' + this.id + '&cancerwith_counseling_topics_id=' + this.counselingId + '&cancerwith_env=' + env
        this.contactUrl = 'https://share.hsforms.com/1Bs-IcJO-TJOoLtoLHONvYQ46sq5?cancerwith_userid=' + this.id + '&cancerwith_counseling_topics_id=' + this.counselingId + '&cancerwith_env=' + env
      }

      // 相談者データを取得
      try {
        let counselingUserData = await API.graphql(graphqlOperation(
          getUser, {id:  this.counselingUserid, limit: 1}
        ))

        this.counselingUserData.displayName = counselingUserData.data.getUser.displayName
        this.counselingUserData.gender = counselingUserData.data.getUser.gender
        this.counselingUserData.age = this.getAge(counselingUserData.data.getUser.birthDate)
        this.counselingUserData.relationship = counselingUserData.data.getUser.relationship
        this.counselingUserData.cancerType = JSON.parse(counselingUserData.data.getUser.cancerType).join('、')
        this.counselingUserData.cancerStage = counselingUserData.data.getUser.cancerStage
        this.counselingUserData.diagnosedReason = counselingUserData.data.getUser.diagnosedReason
        this.counselingUserData.diagnosedDate = counselingUserData.data.getUser.diagnosedDate
        this.counselingUserData.hospitalName = counselingUserData.data.getUser.hospitalName
        this.counselingUserData.curativeStatus = counselingUserData.data.getUser.curativeStatus
        this.counselingUserData.cancerHistory = counselingUserData.data.getUser.cancerHistory
        this.counselingUserData.iconUrl = this.download(counselingUserData.data.getUser.iconImageKey, null, 'main', '', counselingUserData.data.getUser.iconUploadedIdentityId)
        this.counselingUserData.isOfficialTestAccount = this.isOfficialTestAccount(counselingUserData.data.getUser.mailAddress)
        if (!this.counselingUserData.iconUrl) {
          this.counselingUserData.iconUrl = counselingUserData.data.getUser.iconDefaultUrl
        }
        if (!this.counselingUserData.iconUrl) {
          this.counselingUserData.iconUrl = 'https://cancerwith.s3-ap-northeast-1.amazonaws.com/profile/default-profile-img.png'
        }
      } catch (err) {
        this.counselingRepliedData = []
      }
      this.isLoading = false


    } catch (err) {
      this.counselingId = ''
      this.counselingCategory1 = ''
      this.counselingCategory2 = ''
      this.counselingText = ''
      this.imageKey1 = ''
      this.imageKey2 = ''
      this.imageKey3 = ''
      this.imageUploadedIdentityId1 = ''
      this.imageUploadedIdentityId2 = ''
      this.imageUploadedIdentityId3 = ''
      this.responseEstimatedDate = ''
      this.status = ''
      this.isSolved = false
      this.createAt = ''
      this.isOwnTopics = false
      this.ratingsUrl = ''
      this.violationReportsUrl = ''
      this.contactUrl = ''
      this.loadMessage = '権限がありません'
      this.isLoading = false
    }

    // 回答内容取得
    try {
      this.counselingRepliedData = await API.graphql(graphqlOperation(
        listCounselingRepliesBySpecificCounselingTopicsId, {counselingTopicsId: this.$route.params.counselingTopicsId}
      ))
      this.counselingRepliedData = this.counselingRepliedData.data.listCounselingRepliesBySpecificCounselingTopicsId.items

      this.counselingRepliedData.sort (function(a, b) {
        if (new Date(a.createAt) < new Date(b.createAt)) {
          return -1
        } else {
          return 1
        }
      })

      this.counselingRepliedCount = this.counselingRepliedData.length

      for (let i in this.counselingRepliedData) {
        var replierUserid = this.counselingRepliedData[i].replierUserid
        this.repliedUserIds.push(replierUserid)
        this.download(this.counselingRepliedData[i].imageKey1, 1, 'getUrl', i, this.counselingRepliedData[i].imageUploadedIdentityId1)
        this.download(this.counselingRepliedData[i].imageKey2, 2, 'getUrl', i, this.counselingRepliedData[i].imageUploadedIdentityId2)
        this.download(this.counselingRepliedData[i].imageKey3, 3, 'getUrl', i, this.counselingRepliedData[i].imageUploadedIdentityId3)

        // Userデータを取得
        try {
          let replierUserData = await API.graphql(graphqlOperation(
            getUser, {id: replierUserid, limit: 1}
          ))
          
          var tmpData = this.counselingRepliedData[i]
          tmpData.replyText = tmpData.replyText.replace(/\r?\n/g, '<br>')
          tmpData.displayName = replierUserData.data.getUser.displayName
          tmpData.affiliation = replierUserData.data.getUser.affiliation
          tmpData.businessTitle = replierUserData.data.getUser.businessTitle
          tmpData.iconUrl = this.download(replierUserData.data.getUser.iconImageKey, null, 'icon', i, replierUserData.data.getUser.iconUploadedIdentityId)
          if (!tmpData.iconUrl) {
            tmpData.iconUrl = replierUserData.data.getUser.iconDefaultUrl
          }
          if (!tmpData.iconUrl) {
            tmpData.iconUrl = 'https://cancerwith.s3-ap-northeast-1.amazonaws.com/profile/default-profile-img.png'
          }
          
          this.counselingRepliedData.splice(i, 1, tmpData)
        } catch (err) {
          this.counselingRepliedData[i].displayName = ''
          this.counselingRepliedData[i].affiliation = ''
          this.counselingRepliedData[i].businessTitle = ''
          this.counselingRepliedData[i].iconUrl = null
        }
      }
      this.isReplyLoading = false
    } catch (err) {
      this.counselingRepliedData = []
      this.isReplyLoading = false
    }

    // 相談者の過去の相談取得
    try {
      this.pastCounselingData = await API.graphql(graphqlOperation(
        listCounselingTopicsBySpecificCounselingUserid, {counselingUserid: this.counselingUserid, limit: 99999}
      ))
      this.pastCounselingData = this.pastCounselingData.data.listCounselingTopicsBySpecificCounselingUserid.items

      this.pastCounselingData.sort (function(a, b) {
        if (new Date(a.createAt) > new Date(b.createAt)) {
          return -1
        } else {
          return 1
        }
      })
      this.pastCounselingData = this.pastCounselingData.splice(0, 10)
    } catch (err) {
      this.pastCounselingData = []
    }

    var guideAdviser = this.getGuideAdviser(location.hostname)
    this.adviserName = guideAdviser.adviserName
    this.adviserLink = guideAdviser.adviserLink
    this.adviserImage = guideAdviser.adviserImage

    Analytics.record({
      name: 'accessLog', 
      attributes: { 
        page: 'CounselingDetail',
        url: window.location.origin + window.location.pathname,
        userid: this.id,
        userType: this.userType,
        counselingTopicsId: this.counselingId
      }
    });

    // GA
    if (location.hostname === 'cancerwith.com') {
      if (this.userType === 'user') {
        this.$gtag.pageview({
          page_path: '/user/counselingDetail',
          page_title: 'User:相談詳細 (/counselingDetail)'
        })
      } else if (this.userType === 'adviser') {
        this.$gtag.pageview({
          page_path: '/adviser/counselingDetail',
          page_title: 'Adviser:相談詳細 (/counselingDetail)'
        })
      }
    }
  }
};
</script>

<style src="./assets/style.css" />
